import styled from "@emotion/styled";
import UI from "@mile-meeting/mile-ui";
import ToolTip from "uis/new-tootip";

const NoshowTableHeader = () => {
  return (
    <HeaderContainer>
      <LabelContainer minWidth={280} maxWidth={"100%"} style={{ flex: 1 }}>
        <UI.Typography type="label01" fontStyle="medium" color="var(--alias-color-label-normal)">
          예약 정보
        </UI.Typography>
      </LabelContainer>
      <LabelContainer minWidth={120} maxWidth={140}>
        <UI.Typography type="label01" fontStyle="medium" color="var(--alias-color-label-normal)">
          노쇼 발생 일자
        </UI.Typography>
      </LabelContainer>
      <LabelContainer minWidth={100} maxWidth={120}>
        <UI.Typography type="label01" fontStyle="medium" color="var(--alias-color-label-normal)">
          예약 시작/종료 시간
        </UI.Typography>
      </LabelContainer>
      <LabelContainer minWidth={100} maxWidth={100}>
        <UI.Typography type="label01" fontStyle="medium" color="var(--alias-color-label-normal)">
          기간 내 노쇼 횟수
        </UI.Typography>
      </LabelContainer>
      <LabelContainer minWidth={237} maxWidth={237}>
        <UI.Typography type="label01" fontStyle="medium" color="var(--alias-color-label-normal)">
          반복 예약 취소/취소 요청
        </UI.Typography>
        <ToolTip
          zIndex={0}
          icon="info"
          text="예약 취소 권한이 있고, 취소 가능한 잔여 예약이 존재할 경우에만 취소/취소 요청 버튼을 제공합니다."
          position={{ top: -30, left: -464 }}
        />
      </LabelContainer>
    </HeaderContainer>
  );
};

export default NoshowTableHeader;

const HeaderContainer = styled.div`
  display: flex;
  min-width: 832px;
  width: 100%;
  box-sizing: border-box;
  flex: 1;
  padding: 12px 24px;
  align-items: center;
  gap: 20px;

  border-radius: 12px;
  background-color: #9299a014;
`;

const LabelContainer = styled.div<{ minWidth: number; maxWidth: number | string }>`
  display: flex;
  min-width: ${(props) => props.minWidth}px;
  max-width: ${(props) => props.maxWidth}px;
  align-items: center;
  gap: 4px;
  flex: 1;

  p {
    white-space: nowrap;
  }
`;
